import React, { useId } from 'react';
import { BannerProps } from './Banner.types';
// @ts-ignore
import Text from 'components/corporatiu/Text';
// @ts-ignore
import BotoComponent from 'components/corporatiu/Boto';
const Boto: any = BotoComponent;
// @ts-ignore
import ImatgeComponent from 'components/corporatiu/Imatge/Imatge';
// @ts-ignore
import IconaComponent from 'components/corporatiu/Icona/';

import clsx from 'clsx';
import __isEmpty from 'lodash/isEmpty';
import styles from './banner.module.scss';

const Icona: any = IconaComponent;
const Imatge: any = ImatgeComponent;

export default function Banner(props: Readonly<BannerProps>) {
    const {
        aspectRatio = '16 / 9',
        call_to_action = 'Consulta-ho',
        className,
        entradeta,
        estil,
        icona,
        imatge,
        item,
        link,
        logo,
        mostraEntradeta = true,
        mostraFormes,
        posicioImatge = 'esquerra',
        routePath,
        tipus
    } = props;

    const { domini, id, imatges, nombonic, tipologia, titol, url } = item || props;

    const route = {
        type: routePath,
        slug: nombonic || titol,
        id: id === undefined ? undefined : String(id),
        domini: domini,
        tipologia: tipologia,
        href: url
    };

    const titolId = `banner-title-${useId()}`;

    const stylesBanner = clsx({
        [styles.b]: true,
        [styles[estil as string]]: !__isEmpty(estil),
        [className as string]: !__isEmpty(className),
        [styles.formes as string]: mostraFormes === true
    });

    const _mostraBoto = () =>
        call_to_action && link ? (
            <Boto tema='negre' text={call_to_action} className={styles.boto} link={link} />
        ) : (
            <Boto tema='negre' text={call_to_action} className={styles.boto} route={route} />
        );

    if (titol == '') return null;

    return (
        <div
            role='region'
            aria-labelledby={titolId}
            className={stylesBanner}
            data-tipus={tipus}
            data-posicio-imatge={posicioImatge}
        >
            {(imatges || imatge) && (
                <div
                    className={styles.imatgeWrapper}
                    aria-hidden='true'
                    style={{ '--aspect-ratio': aspectRatio } as React.CSSProperties}
                >
                    <Imatge
                        imatges={imatges}
                        src={imatge}
                        tipus='web_destacat'
                        alt=''
                        layout='fill'
                        priority={true}
                        objectFit='cover'
                        className={styles.imatge}
                    />
                </div>
            )}

            <div className={styles.content}>
                {icona && (
                    <Icona
                        icona={icona}
                        inline={true}
                        alt='Icon image'
                        mida='mitjana'
                        ariaHidden={false}
                        className={styles.icona}
                    />
                )}
                {logo && (
                    <div className={styles.logoWrapper}>
                        <Imatge src={logo} alt={titol} layout='fill' objectFit='contain' className={styles.logo} />
                    </div>
                )}
                {titol && logo == undefined && <Text className={styles.titol} text={titol} idDom={titolId} />}
                {entradeta && mostraEntradeta && <Text className={styles.entradeta} text={entradeta} />}
                {_mostraBoto()}
            </div>
        </div>
    );
}
